import { GroupsOfGroup } from '@era/security-sdk';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export function selectUserIdFromParent(group: GroupsOfGroup) {
  return group.parentGroupId ? `${group.groupId}-${group.parentGroupId}` : group.groupId;
}
export const adapter: EntityAdapter<GroupsOfGroup> = createEntityAdapter<GroupsOfGroup>({
  selectId: selectUserIdFromParent,
});

export type GroupsOfGroupState = EntityState<GroupsOfGroup>;

export const initialstate: GroupsOfGroupState = adapter.getInitialState();
